import * as tags from "../constants/tags.js";
import {
  ABSTRACTION_STEPS,
  ABSTRACT_REQUEST_STATUSES,
} from "../constants/abstraction-statuses.js";

export default {
  back: "Back",

  // Not Found
  couldNotFindPage: "We couldn't find the page you were looking for.",
  pageNotFound: "404 Page Not Found",
  backToHome: "Back to home",

  // Access Denied
  accessDenied: "Access Denied",
  tryLoggingInAgain: "Please try logging in again to continue.",

  // Login Page
  login: "Log In",
  loginOrSignup: "Log In or Sign up",
  instantAbstraction: "Instant Abstraction",
  startsHere: "Starts Here",
  forMoreInformation:
    "For more information, please visit <a>prophia.com/instant-lease-abstract</a>",
  continue: "Continue",
  continueWithEmail: "Continue with Email",
  prophiaAbstract: "Prophia Abstract",
  continueWith: "Continue with",
  email: "Email",
  password: "Password",
  showPassword: "Show Password",
  hidePassword: "Hide Password",
  or: "or",
  signUpCTA: "Don't have an account? <a>Sign up for free</a>",
  invalidEmailPassword: "Invalid email and/or password",
  forgotPassword: "Forgot Password",
  rememberMe: "Remember Me",
  sessionExpired: "Your session has expired. Please log in again.",
  loginSuccessful: "Login Successful",
  loadingYourAccount: "Loading your account",
  loading: "Loading",

  // Sign Up Page
  signUp: "Sign Up",
  createANewAccount: "Create a New Account",
  firstName: "First Name",
  lastName: "Last Name",
  firstNamePlaceholder: "First",
  lastNamePlaceholder: "Last",
  chooseAPassword: "Choose a Password",
  confirmPassword: "Confirm Password",
  jobFunction: "Job Function",
  howDidYouHearAboutUs: "How did you hear about us?",
  optional: "Optional",
  termsOfServiceMessage: "I agree to the <a1>Terms of Service</a1>",
  termsOfService: "Terms of Service",
  linkedInReddit: "LinkedIn or Reddit",
  referralWordOfMouth: "Referral or Word of Mouth",
  advisor: "Advisor",
  onlineSearch: "Online Search",
  conferenceEvent: "Conference or Event",
  newsArticle: "News Article",
  other: "Other",
  accountWithEmailAlreadyExists:
    "This email is already associated with another login method. Please choose a different login method or create an account using a different email.",

  brokerageLeasing: "Brokerage - Leasing",
  brokerageInvestmentSales: "Brokerage - Investment Sales",
  brokerageDebt: "Brokerage - Debt",
  ownerOperator:
    "Owner/Operator (Property & Asset Management, Equity Investor, etc)",
  dataTechProvider: "Data or Technology Provider",
  advisoryServicesFirm: "Advisory or Services Firm",
  appraisalValuation: "Appraisal/Valuation",
  occupierTenant: "Occupier/Tenant",
  legal: "Legal",
  selectAFunction: "Select a function",

  // Reset Password Page
  resetPassword: "Reset Password",
  enterANewPassword: "Enter a New Password",
  savePassword: "Save Password",
  passwordMustBeNew: "Your password cannot be the same as the last one",
  passwordSuccessfullyReset: "Password successfully reset!",
  gotoLogin: "Go to Login Page",
  emailLinkExpired: "Email verification link has expired",
  willBeRedirected:
    "You'll be automatically redirected in {{seconds}} seconds.",
  clickHere: "Click here",
  ifNotAutomaticallyRedirected: "If you're not redirected automatically.",

  //Forgot Password Page
  resetPasswordText:
    "Enter your email address and we will send you a link to reset your password.",
  enterEmail: "Enter login email address",
  sendEmail: "Send Email",
  passwordLinkSent: "Reset Password Link Sent!",
  resendLink: "Re-send Link",
  resendLinkText:
    "If you dont see an email from us in the next 2 minutes, please try re-sending the link",

  // Select Input
  selectAnOption: "Select an Option",
  expand: "Expand",
  collapse: "Collapse",

  // Text Input
  showText: "Show Text",
  hideText: "Hide Text",

  // Validation
  thisFieldIsRequired: "This field is required",
  passwordsDoNotMatch: "Passwords do not match",
  somethingWentWrong: "Something went wrong",
  somethingWentWrongTryAgain: "Something went wrong, please try again",

  // Nav
  logout: "Log out",
  youWillBeLoggedOut:
    "You will be logged out of Prophia Abstract. You will need to sign-in again to access your account",
  account: "Account",
  support: "Support",
  home: "Home",
  supportMessage: "Need help or have some feedback?",
  supportLinkMessage:
    "Contact us at <a1>abstract@prophia.com</a1> or <a2>sign up </a2> to talk with us",
  visitSupportCenter: "Visit Support Center",

  // User Info Page
  justAFewMoreDetails: "Just a few more details",

  //Home Page
  uploadLimits: "PDF only (max. 30MB)",
  selectAFile: "<a>Select a document</a> or drag and drop",
  selectDocuments: "<a>Select documents</a> or drag and drop",
  abstractDocument: "Abstract Document",
  fileSize: "File Size:",
  pdfDocumentsOnly: "PDF Documents Only",
  uploadAPdf: "Only PDF documents are allowed. Please upload a valid PDF file.",
  fileTooLarge: "File Too Large",
  exceedsFileSizeLimit:
    "The file you are trying to upload exceeds the file size limit of <a>30MB</a>. Please upload a smaller file.",
  tooManyFiles: "Attempting to upload too many files",
  tooManyFilesMessage:
    "You are attempting to upload more than one file. Please upload only one file at a time.",
  createNAbstracts: "Create ({{count}}) Abstracts",
  pendingFilesConfirmCloseDialog:
    "Your documents have not been abstracted! If you leave now, you’ll need to start over. Do you still want to leave?",
  uploadInProgress: "Upload in progress",
  abstractDescriptionTooltipDisabled:
    "Abstraction will be available once all uploads have completed.",
  nSingleDocumentAbstracts: "{{count}} single-document abstracts",
  nMultiDocumentAbstracts: "{{count}} multi-document abstracts",
  oneSingleDocumentAbstract: "1 single-document abstract",
  oneMultiDocumentAbstract: "1 multi-document abstract",
  abstractsBeingProcessed: "Your abstracts are now being processed!",
  trackProgressBelow: "You can track their progress in the table below.",
  uploadAndAbstract: "Upload & Abstract",
  singleDocumentAbstracts: "Single Document Abstracts",
  multiDocumentAbstracts: "Multi Document Abstracts",
  singleDocumentAbstractsDescription:
    "Each document uploaded here will create its own abstract",
  multiDocumentAbstractsDescription:
    "Each abstract group will create a single consolidated abstract",
  individualAbstracts: "Individual Abstracts",
  createAGroup: "Create a Group",
  abstractGroup: "Abstract Group",
  document: "Document",
  documents: "Documents",
  createAbstracts: "Create Abstracts",
  createAbstract: "Create Abstract",
  deleteGroupModalMessage:
    "This group contains {{documentCount}} document(s). Deleting this group will permanently remove all documents within it. Are you sure you want to delete this group?",
  confirmDeletion: "Confirm Deletion",

  // Footer
  privacyPolicyFooterMessage:
    "© Prophia, Inc | <a1>Privacy Policy</a1> | <a2>Terms of Service</a2> | <a3>abstract@prophia.com</a3>",
  privacyPolicy: "Privacy Policy",

  // Abstract Configuration
  configureAbstract: "Configure Abstract",
  configureYourAbstract: "Configure Your Abstract",
  whatTermsWouldYouLike: "What terms would you like in your abstract?",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  selectedTermsCountInfo:
    "{{current}} of {{total}} terms have been selected for abstraction",
  configurationTooltipInfo: "Terms cannot be added to an abstract later",

  // Table
  noData: "No data",

  // Abstract List
  noAbstractDataMessage: "Upload a document above to get started!",
  searchForDocumentName: "Search for Document Name",
  noDataMessage: "Upload a document above to get started!",
  searchForAbstract: "Search for Abstract",
  [ABSTRACTION_STEPS.READING_DOCUMENT]: "Reading Document",
  [ABSTRACTION_STEPS.VALIDATING]: "Validating",
  [ABSTRACTION_STEPS.CONSOLIDATING_LEASE]: "Consolidating Lease",
  [ABSTRACTION_STEPS.RETRIEVING_DATA]: "Retrieving Data",
  [ABSTRACT_REQUEST_STATUSES.PROCESSING]: "Processing Document",
  [ABSTRACT_REQUEST_STATUSES.COMPLETED]: "Complete",
  [ABSTRACT_REQUEST_STATUSES.FAILED]: "Failed",
  [`${ABSTRACTION_STEPS.READING_DOCUMENT}.abbreviated`]: "Reading",
  [`${ABSTRACTION_STEPS.VALIDATING}.abbreviated`]: "Validating",
  [`${ABSTRACTION_STEPS.CONSOLIDATING_LEASE}.abbreviated`]: "Consolidating",
  [`${ABSTRACTION_STEPS.RETRIEVING_DATA}.abbreviated`]: "Retrieving Data",
  [`${ABSTRACT_REQUEST_STATUSES.PROCESSING}.abbreviated`]: "Processing",
  [`${ABSTRACT_REQUEST_STATUSES.COMPLETED}.abbreviated`]: "Complete",
  [`${ABSTRACT_REQUEST_STATUSES.FAILED}.abbreviated`]: "Failed",
  allAbstracts: "All Abstracts",
  fileName: "File Name",
  abstract: "Abstract",
  abstractDate: "Abstract Date",
  uploadDate: "Upload Date",
  numberOfPages: "Number of Pages",
  numberOfDocuments: "# of Documents",
  status: "Status",
  downloadDocument: "Download Document",
  downloadDocuments: "Download Documents",
  downloadAbstract: "Download Abstract",
  retryAbstract: "Retry Abstract",
  retry: "Retry",
  delete: "Delete",
  deleteAbstract: "Delete Abstract",
  youAreTryingToDeleteThisAbstract:
    'You are trying to delete "{{filename}}". This will permanently delete this abstract, do you wish to continue?',
  downloadSelected: "Download {{count}} Abstracts",
  abstractZipFile: "abstracts.zip",
  abstractName: "Abstract Name",
  somethingWentWrongTryAbstractAgain:
    "Something went wrong. Please try running the abstract again.",
  reUploadOrContactUs:
    "Please try re-uploading the document/s again or contact us at <a>abstract@prophia.com</a",
  clickToRetry: "Click here to retry.",
  retriesRemaining: "{{retriesRemaining}} retries remaning.",

  // password validator
  passwordStrength: "Password Strength",
  requirements: "Requirements",
  itsBetterToHave: "It's better to have",
  atLeast8Chars: "At least 8 characters",
  atLeaseOneNumOrSymbol: "At least one number or symbol",
  atLeaseOneUpperAndLowerCase: "One uppercase & one lowercase letter",
  noNameEmailReference: "No reference to your name or email",
  longerPassword: "At least 12 characters",
  numberAndSymbol: "Number and symbol (e.g. $,#,@,!)",
  average: "average",
  weak: "weak",
  good: "good",
  strong: "strong",
  invalidPassword: "Invalid Password",

  // Account Settings
  accountSettings: "Account Settings",
  updateEmail: "Update Email",
  updatePassword: "Update Password",
  myProfile: "My Profile",
  myAccount: "My Account",
  edit: "Edit",
  deleteAccount: "Delete Account",
  deleteMyAccount: "Delete my account",
  deleteAccountMessage:
    "If you no longer wish to use Prophia Abstract, you can permanently delete your account",
  saveChanges: "Save Changes",
  cancel: "Cancel",
  ok: "OK",
  enterCurrentPassword: "Enter Current Password",
  incorrectPassword: "Incorrect Password",
  thirdPartyConnection: "Third-Party Connection",
  transactionHistory: "Transaction History",
  searchForDocumentNameOrTransaction: "Search for doc name or transaction id",
  date: "Date",
  description: "Description",
  numberOfAbstracts: "# of Abstracts",
  transactionId: "Transaction ID",
  totalCost: "Total Cost",
  noTransactionDataMessage: "No transaction data found",
  documentAbstract: "Document Abstract",
  refundDocumentAbstract: "Refund - Document Abstract",
  PENDING: "Pending",
  PAID: "Paid",
  CANCELLED: "Cancelled",
  PARTIALLY_REFUNDED: "Partially Refunded",
  ABANDONED: "Abandoned",
  COMPLETELY_REFUNDED: "Refunded",
  REFUNDED: "Refunded",
  refundPending: "Refund Pending",
  refundDenied: "Refund Denied",
  viewReceipt: "View Receipt",
  failedToAbstract: "failed to abstract",
  refundRequest: "Refund Request",
  requestRefund: "Request Refund",
  selectAbstractsForRefund: "Select abstracts for refund",
  selectAbstracts: "Select abstracts",
  selectedAbstracts: "Selected Abstracts",
  reasonForRequest: "Reason for request",
  haveFeedback: "Have feedback for us? Sign up <a>here</a> to talk with us",
  selectAtLeastOneAbstract: "Please select at least one abstract",
  refundRequestSubmitted: "Refund request submitted",
  refundRequestSuccess:
    "Your refund request has been successfully submitted. You will receive a response within the next 3-5 business days. Please check your email for updates on the status of your request.",
  furtherQuestions:
    "If you have any further questions, feel free to contact us.",
  refundRequested: "Refund Requested",
  allAbstractsRemoved: "All abstracts have since been removed or deleted",
  deletedAbstracts: "Deleted Abstracts",
  promoCode: "Promo Code",
  freeAbstracts: "{{number}} Free Abstracts",
  enterYourPromoCode: "Enter your promo code",
  apply: "Apply",
  promoCodeApplied: "Promo code applied!",
  addPromoCode: "Add Promo Code",
  freeAbstract: "{{number}} Free Abstract",

  // Notifications
  emailNotifications: "Email Notifications",
  receiveAbstractsCompleteEmail:
    "Receive an email notification when your abstract is ready for viewing",

  // Plans & Pricing
  viewAllPlans: "View all plans",
  pricingAndBilling: "Pricing & Billing",
  loggedIn: "Logged in",
  plansAndPricing: "Plans & Pricing",
  currentPlan: "Current Plan",
  basicPlan: "Basic Plan",
  customPlan: "Custom",
  proPlan: "Pro Plan",
  businessPlan: "Business Plan",
  freeIndividualUserAccount: "Free Individual User Account",
  dollarsPerAbstract: "$20 per abstract",
  unlimitedStorage: "Unlimited Storage",
  abstractableDataPoints: "34 abstractable data points",
  comingSoon: "Coming Soon",
  perMonth: "per month",
  subjectToChange: "Subject to change",
  current: "Current",
  prophiaAbstractPlans: "Prophia Abstract Plans",
  proPlanDescription:
    "If you are interested or have any questions, please reach out to us at abstract@prophia.com",
  businessPlanDescription:
    "If you are interested or have any questions, please reach out to us at abstract@prophia.com",
  customSSO: "Custom SSO",
  apiAccess: "API Access",
  custom: "Custom",
  configurable: "Configurable",
  standard: "Standard",
  abstractSummaryView: "Abstract Summary View",
  multiDocumentAbstract: "Multi-Document Abstract",
  aiDocumentQA: "AI Document Q&A",
  excelExport: "Excel Export",
  advanced: "Advanced",
  numberOfDataPoints: "# of Data Points",
  unlimited: "Unlimited",
  storage: "Storage",
  contactUs: "Contact Us",
  tenUsers: "10 Users",
  oneUser: "1 User",
  numberOfUsers: "# of Users",
  basicPriceShortDescription: "$20/per abstract",
  proPriceShortDescription: "Includes 20 abstracts",
  businessPriceShortDescription: "Includes 50 abstracts",

  // Delete Account
  doYouWantToPermanentlyDelete:
    "Do you want to permanently delete your account?",
  youWillDeleteEverything:
    "You will delete all of the documents and abstracts associated with this account. You will no longer have access to any data associated with this account.",
  reasonForDeletion: "Reason for Deletion",
  reason: "Reason",
  selectAReason: "Select a reason",
  noLongerUsingService: "No longer using the service",
  foundADifferentSolution: "Found a different solution",
  costConcerns: "Cost concerns",
  missingDataPoints: "Missing data points",
  missingProductFeatures: "Missing product features",
  technicalIssuesAndBugs: "Technical issues and bugs",
  securityOrPrivacyConcerns: "Security or privacy concerns",
  companyOrRoleChange: "Company or role change",
  permanentlyDeleteAccount: "Permanently Delete Account",
  letUsKnowYourReason: "Let us know your reason here",

  // Account Deleted Page
  yourAccountHasBeenDeleted: "Your account has been deleted.",
  thankYouForBeingAProphiaUser:
    "Thank you for being a Prophia user since {{signupDate}}.",
  weAreSorryToSeeYouGo: "We're sorry to see you go.",
  signUpForAnotherAccount:
    "If you'd like to try us again, just sign up for a new account.",
  goToHomepage: "Go to homepage",

  // Abstract Summary
  abstractSummary: "Abstract Summary",
  abstractedOn: "Abstracted on",
  transactionDetails: "Transaction Details",
  buildingDetails: "Building Details",
  commercialTerms: "Commercial Terms",
  rightsAndOptions: "Rights and Options",
  noneFound: "None Found",
  pageNumber: "Page {{pageNumber}}",
  numberOfTerms: "# of Terms Selected",
  numberOfDocumentsAbstracted: "# of Documents Abstracted",
  viewDocumentTimeline: "View Document Timeline and Summary",
  documentName: "Document Name",
  documentTimeline: "Document Timeline",
  showOneMoreReference: "Show 1 more reference",
  showMoreReferences: "Show {{count}} more references",
  mostUpToDate: "Most up-to-date",
  consolidatedAbstract: "Consolidated Abstract",

  // Error Boundary
  oopsAnErrorOccurred: "Oops! An unexpected error occurred.",
  ifThisErrorPersists:
    "If this error persists please contact abstract@prophia.com",

  // Errors
  ["Entity not found"]: "We were not able to fetch the requested resource",
  promoAlreadyUsed: "Promo code was already used",
  maxAbstractsExceeded:
    "Would exceed maximum amount ({{number}}) of free abstracts.",
  invalidPromo: "Invalid promo code",
  // Email Verification
  registrationComplete: "Almost Done!",
  registrationCompleteSubtitle:
    "A verification email has been sent to {{email}}.",
  registrationCompleteTimeout: "You will have 10 minutes to verify your email",
  sendLinkAgain: "Send link again",
  emailSentSuccessfully: "Email sent successfully",
  emailVerified: "Email Verified",
  youHaveSuccessfullyVerifiedYourEmail:
    "You have successfully verified your email. You will be automatically redirected to the login page in {{seconds}} seconds.",
  goToLoginPage: "Go to Login Page",
  emailVerificationFailed: "Email Verification Failed",
  verifyingYourEmail: "Verifying your email...",
  emailVerificationFailedSubtitle:
    "The verification link is no longer valid. Please try logging into your account or resetting your password.",
  pageAbbreviation: "Pg",
  page: "Page",

  //Job Dashboard
  jobDashboard: "Job Dashboard",
  summary: "Summary",
  jobStatusActive: "Active",
  jobStatusCompleted: "Completed",
  jobStatusPending: "Pending",
  jobStatusFailed: "Failed",
  jobStatusWaiting: "Waiting",
  jobStatusCancelled: "Cancelled",

  //Job Detail
  jobId: "ID",
  jobName: "Name",
  jobStatus: "Status",
  jobPriority: "Priority",
  jobAttemptsMade: "Attempts Made",
  jobAttemptsStarted: "Attempts Started",
  jobMaxAttempts: "Max Attempts",
  jobCreated: "Created",
  jobProcessed: "Processed",
  jobFinished: "Finished",
  jobReturnValue: "Return Value",
  jobStackTrace: "Stack Trace",
  jobOptions: "Options",
  latestFailure: "Latest Failed Job",
  jobData: "Job Data",
  jobErrorReason: "Error Reason",
  jobErrorStacktrace: "Stacktrace",

  // Tags
  [tags.TRANSACTION_TYPE]: "Document Type",
  [tags.TENANT_LEGAL_NAME]: "Tenant Legal Name",
  [tags.LANDLORD_LEGAL_NAME]: "Landlord Legal Name",
  [tags.LANDLORD_BROKER]: "Landlord Broker",
  [tags.TENANT_BROKER]: "Tenant Broker",
  [tags.BUILDING_ADDRESS]: "Building Address",
  [tags.RENTABLE_SQUARE_FOOTAGE]: "Rentable Square Footage",
  [tags.SUITE_NUMBERS]: "Suite Numbers",
  [tags.EFFECTIVE_DATE]: "Effective Date",
  [tags.COMMENCEMENT_DATE]: "Commencement Date",
  [tags.TERM]: "Term",
  [tags.EXPIRATION_DATE]: "Expiration Date",
  [tags.TENANT_IMPROVEMENT]: "Tenant Improvement",
  [tags.RENT_ABATEMENT]: "Rent Abatement",
  [tags.BASE_RENT_SCHEDULE]: "Base Rent Schedule",
  [tags.SECURITY_DEPOSITY_AMOUNT]: "Security Deposit",
  [tags.LETTER_OF_CREDIT_AMOUNT]: "Letter of Credit",
  [tags.RENEWAL_OPTION]: "Renewal Option",
  [tags.EARLY_TERMINATION]: "Early Termination",
  [tags.RIGHT_TO_SUBLET]: "Right to Sublet",
  [tags.RENT_COMMENCEMENT_DATE]: "Rent Commencement Date",
  [tags.TAX_ABATEMENT]: "Tax Abatement",
  [tags.PERCENT_RENT]: "Percentage Rent",
  [tags.LATE_FEE]: "Late Fee",
  [tags.PRO_RATA_SHARE]: "Pro Rata Share",
  [tags.OPEX_PRO_RATA_SHARE]: "Opex Pro Rata Share",
  [tags.TAX_PRO_RATA_SHARE]: "Tax Pro Rata Share",
  [tags.RIGHT_OF_FIRST_OFFER]: "Right of First Offer",
  [tags.RIGHT_OF_FIRST_REFUSAL]: "Right of First Refusal",
  [tags.PARKING]: "Parking",
  [tags.LANDLORD_RELOCATION]: "Landlord Relocation",
  [tags.EXPANSION]: "Expansion",
  [tags.EXCLUSIVE_USE]: "Exclusive Use",
  [tags.PURCHASE_RIGHT]: "Purchase Right",
  [tags.ESTOPPEL]: "Estoppel",
  [tags.LANDLORD_TERMINATION]: "Landlord Termination",
  [tags.CONTRACTION]: "Contraction",
  [tags.PERMITTED_USE]: "Permitted Use",
  [tags.PROHIBITED_USE]: "Prohibited Use",
  [tags.GUARANTOR]: "Guarantor",
  [tags.SIGNAGE]: "Signage",
  [tags.TELECOM]: "Telecom",

  // Abstract Viewer
  bookmarks: "Bookmarks",
  highlights: "Highlights",
  pg: "Pg",
  zoom: "Zoom",
  ZOOM_TO_FIT: "Zoom to Fit",

  // Switch Button
  on: "On",
  off: "Off",

  // Under Construction
  plannedMaintenance: "Scheduled Maintenance in Progress",
  checkBackSoon:
    "We are currently undergoing scheduled maintenance. We apologize for the temporary inconvenience and appreciate your patience!",
  estimatedDowntime: "Estimated downtime: ~ {{timeRemaining}} ({{endTime}})",

  //Excel Export
  documentSummarySheetName: "Document Summary",
  leaseAbstractSheetName: "Lease Abstract",

  docNumber: "Doc #",
  documentType: "Document Type",
  effectiveDate: "Effective Date",
  capturedTerms: "Captured Terms",
  summaryOfChanges: "Summary of Changes",
  reference: "Reference",
  refNumber: "Ref #",
  value: "Value",
  generatedByProphia: "Generated by Prophia using AI",
  visitProphia: "Visit Prophia Abstract to generate your own abstract",
  requestJobId: "Job ID",
  reportRunOn: "Report Run On",
  referenceSummary: "Reference Summary",
};
